import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ImportStatusEnum } from 'exports/interfaces/import-status.enum';
import { ImportsMonitoringChannelDrilldownImport } from 'exports/interfaces/imports-monitoring-channel.interface';
import { ImportPartialSuccessStatusDisplayTooltipComponent } from 'shared/components/ag-grid/cell-renderers/import-partial-success-status-display-renderer/import-partial-success-status-display-tooltip/import-partial-success-status-display-tooltip.component';
import { TooltipDirective } from 'shared/directives/tooltip.directive';

@Component({
    selector: 'app-import-partial-success-status-display-renderer',
    imports: [TooltipDirective, CommonModule],
    templateUrl: './import-partial-success-status-display-renderer.component.html',
    styleUrl: './import-partial-success-status-display-renderer.component.scss',
})
export class ImportPartialSuccessStatusDisplayRendererComponent implements ICellRendererAngularComp {
    importStatusEnum = ImportStatusEnum;
    data: ImportsMonitoringChannelDrilldownImport | null = null;

    tooltipComponent = ImportPartialSuccessStatusDisplayTooltipComponent;

    agInit(params: ICellRendererParams): void {
        this.data = params.data as ImportsMonitoringChannelDrilldownImport;
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
